// Module
var code = "<dl class=\"ndd-ng-data\" [ngClass]=\"{ 'ndd-ng-data--row': dataOrientation === 'row', 'ndd-ng-data--column': dataOrientation === 'column' }\"> <ng-content></ng-content> </dl> ";
// Exports
module.exports = code;